import React from "react";
import PropTypes from "prop-types";

import AnimatedContainer from "../../../../lib/utils/AnimatedContainer";
import { EventInfo } from "../../shared/components";
import { Map } from "../../shared/components";

const EventHeader = (props) => {
  const {
    event,
    event: { description, name, address },
  } = props;

  const html = { __html: description };

  return (
    <div className="event-header primary-color-background">
      <div className="title">
        <h2 className="event-header-title">{name}</h2>
      </div>

      <div className="description">
        <div className="row">
          <div className="col-md-6">
            <div className="p-md-b">
              <EventInfo event={event} />
            </div>
            <div
              className="event-border-top p-lg-l p-lg-r p-md-t p-md-b"
              dangerouslySetInnerHTML={html}
            />
          </div>

          <div className="col-md-6">
            <Map address={address} />
          </div>
        </div>
      </div>
    </div>
  );
};

EventHeader.propTypes = {
  event: PropTypes.object.isRequired,
};

export default EventHeader;
